// FIXED router/index.js

import { createRouter, createWebHistory } from 'vue-router'
import PharmacyList from '@/components/PharmacyList.vue'
import MedicineList from '@/components/MedicineList.vue'
import CheckoutNow from '@/components/CheckoutNow.vue'
import OrderHistory from '@/components/OrderHistory.vue'
import LoginForm from '@/components/LoginForm.vue'
import UserLogin from '@/components/UserLogin.vue'
import UserOrderHistory from '@/components/UserOrderHistory.vue'


const routes = [
  {
    path: '/pharmacies',
    name: 'PharmacyList',
    component: PharmacyList
  },
  {
    path: '/medicine/:pharmacyId/:pharmacyName',
    name: 'MedicineList',
    component: MedicineList,
    props: route => ({
      selectedPharmacyId: route.params.pharmacyId,
      selectedPharmacyName: route.params.pharmacyName
    })
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: CheckoutNow,
    props: route => ({
      cartItems: route.params.cartItems || [],
      pharmacy: route.params.pharmacy || {}
    })
  },
  {
    path: '/login',
    name: 'LoginForm',
    component: LoginForm
    //meta:{requireGuest:true}
  },
   {
    path: '/user_order_history',
    name: 'UserOrderHistory',
    component: UserOrderHistory
    //meta:{requireGuest:true}
  },
  {
    path: '/',
    name: 'UserLogin',
    component: UserLogin
    //meta:{requireGuest:true}
  },
  {
    path: '/order-history',
    name: 'OrderHistory',
    component: OrderHistory
  }
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router;
 